import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import {
    Paper,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import axios from 'src/utils/axios';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';


const useStyles = makeStyles({
    tableHead: {
        fontWeight: 'bold',
        borderLeft: '1px solid #ddd',
    },
    tableRow: {
        borderLeft: '1px solid #ddd',
    }
});


function ReceiptCustomer() {
    const { PhoneNumber } = useParams();
    const history = useHistory();
    const classes = useStyles();

    const [receiptCustomerData, setReceiptCustomerData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getCustomerInformationFromPhoneNumber();
    }, [])

    const getCustomerInformationFromPhoneNumber = () => {
        axios.get(`GetCustomerInformationFromPhoneNumber/${PhoneNumber}`)
            .then((response) => {
                var customerData = response.data;
                setReceiptCustomerData(customerData);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }


    const handleGoBack = () => {
        history.goBack();
    };

    const RouteReceiptCustomerDetailPage = (CustomerNo) => {
        history.push(`/ReceiptCustomerDetail/${CustomerNo}`);
    }

    return (
        <Grid container spacing={1} style={{ overflow: 'auto', maxHeight: '90vh' }}>
            <Grid item xs={false} sm={false} md={2} />
            <Grid item xs={12} sm={12} md={8}>
                <Paper elevation={3} style={{ marginTop: 20, borderRadius: '1rem' }}>
                    <TableContainer component={Paper} style={{ borderRadius: '1rem' }}>
                        <Table size='small'>
                            <TableHead>
                                <TableRow style={{ backgroundColor: '#0033a0', color: '#fff' }}>
                                    <TableCell colSpan={6}>
                                        <Grid container alignItems="center">
                                            <Grid item xs={1}>
                                                <IconButton onClick={() => { handleGoBack(); }} style={{ color: '#fff' }}>
                                                    <ArrowBackIcon />
                                                </IconButton>
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Typography variant="h5" align="center" style={{ color: '#fff' }}>
                                                    Müşteri Bilgileri
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1} />
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Müşteri
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Semt
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Şehir
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Adres
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Telefon
                                    </TableCell>
                                    <TableCell
                                        align='left'
                                        style={{
                                            border: '1px solid #ddd',
                                            fontSize: '1rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Kayıt Tarihi
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    Array.from(new Array(3)).map((_, index) => (
                                        <TableRow key={index}>
                                            {Array.from(new Array(6)).map((_, cellIndex) => (
                                                <TableCell key={cellIndex} colSpan={1}>
                                                    <Skeleton animation="pulse" variant="text" width={150} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    receiptCustomerData.length > 0 && receiptCustomerData.map((customer, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                align='left'
                                                style={{
                                                    border: '1px solid #ddd'
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer',
                                                        color: '#4C3BCF'
                                                    }}
                                                    onClick={() => { RouteReceiptCustomerDetailPage(customer.MUSTERI_NO); }}
                                                >
                                                    {customer.ADI + ' ' + customer.SOYADI}
                                                </span>
                                            </TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{customer.ILCE}</TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{customer.IL}</TableCell>
                                            <TableCell align='left' style={{ borderRight: '1px solid #ddd' }}>{customer.ADRES}</TableCell>
                                            <TableCell
                                                align='left'
                                                style={{ borderRight: '1px solid #ddd' }}
                                            >
                                                {(customer.TEL1 ? customer.TEL1 : '') + (customer.TEL2 ? ' - ' + customer.TEL2 : '')}
                                            </TableCell>
                                            <TableCell align='left'>{moment(customer.KAYIT_TARIHI).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Grid>
            <Grid item xs={false} sm={false} md={2} />
        </Grid>
    )
}

export default ReceiptCustomer